var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_9496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6395 1.45H13.0895V2.91H11.6395V1.45ZM13.0895 2.91H14.5495V4.36H13.0895V2.91ZM14.5495 4.36H15.9995V5.82H14.5495V4.36ZM14.5495 10.18H15.9995V11.64H14.5495V10.18ZM13.0895 11.64H14.5495V13.09H13.0895V11.64ZM14.5495 8.73H15.9995V10.18H14.5495V8.73ZM14.5495 7.27H15.9995V8.73H14.5495V7.27ZM14.5495 5.82H15.9995V7.27H14.5495V5.82ZM11.6395 13.09H13.0895V14.55H11.6395V13.09ZM10.1795 14.55H11.6395V16H10.1795V14.55ZM10.1795 5.82H11.6395V7.27H10.1795V5.82ZM10.1795 4.36H11.6395V5.82H10.1795V4.36ZM10.1795 0H11.6395V1.45H10.1795V0ZM8.72953 14.55H10.1795V16H8.72953V14.55ZM8.72953 7.27H10.1795V8.73H8.72953V7.27ZM8.72953 2.91H10.1795V4.36H8.72953V2.91ZM8.72953 0H10.1795V1.45H8.72953V0ZM7.26953 14.55H8.72953V16H7.26953V14.55ZM7.26953 11.64H8.72953V13.09H7.26953V11.64ZM7.26953 8.73H8.72953V10.18H7.26953V8.73ZM7.26953 2.91H8.72953V4.36H7.26953V2.91ZM7.26953 0H8.72953V1.45H7.26953V0Z",
    fill: "#56BDC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82 14.55H7.27V16H5.82V14.55ZM5.82 2.91H7.27V4.36H5.82V2.91ZM5.82 0H7.27V1.45H5.82V0ZM4.36 14.55H5.82V16H4.36V14.55ZM4.36 4.36H5.82V5.82H4.36V4.36ZM4.36 0L5.82 0V1.45H4.36V0ZM2.91 13.09H4.36V14.55H2.91V13.09ZM2.91 1.45H4.36V2.91H2.91V1.45ZM1.45 11.64H2.91V13.09H1.45V11.64ZM1.45 2.91H2.91V4.36H1.45V2.91ZM0 10.18H1.45V11.64H0V10.18ZM0 8.73H1.45V10.18H0V8.73ZM0 7.27H1.45V8.73H0V7.27ZM0 5.82H1.45V7.27H0V5.82ZM0 4.36H1.45V5.82H0V4.36Z",
    fill: "#56BDC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_9496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.6fc2fe11bc4420eb31dcfdb46c49772f.svg";
export { ForwardRef as ReactComponent };